<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h2>Hakkyo Martialarts</h2>
      <p class="subtitle">Sistema de Gestión de Exámenes TKD</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="alert alert-danger" *ngIf="errorMessage">
        <i class="fas fa-exclamation-circle"></i>
        {{ errorMessage }}
      </div>

      <div class="form-group">
        <label for="username">Usuario</label>
        <input 
          type="text" 
          id="username"
          formControlName="username" 
          class="form-control" 
          [class.is-invalid]="f.username.invalid && f.username.touched"
          placeholder="Ingrese su usuario"
          autocomplete="username"
        />
        <div class="invalid-feedback" *ngIf="f.username.invalid && f.username.touched">
          El usuario es requerido
        </div>
      </div>

      <div class="form-group">
        <label for="password">Contraseña</label>
        <input 
          type="password" 
          id="password"
          formControlName="password" 
          class="form-control"
          [class.is-invalid]="f.password.invalid && f.password.touched"
          placeholder="Ingrese su contraseña"
          autocomplete="current-password"
        />
        <div class="invalid-feedback" *ngIf="f.password.invalid && f.password.touched">
          La contraseña es requerida
        </div>
      </div>

      <button 
        type="submit" 
        class="btn btn-primary btn-block"
        [disabled]="loading || loginForm.invalid"
      >
        <span *ngIf="!loading">
          <i class="fas fa-sign-in-alt"></i> Iniciar Sesión
        </span>
        <span *ngIf="loading">
          <i class="fas fa-spinner fa-spin"></i> Iniciando sesión...
        </span>
      </button>
    </form>
  </div>
</div>